import { render, staticRenderFns } from "./roundWarning.vue?vue&type=template&id=0a4d3e9e&"
import script from "./roundWarning.vue?vue&type=script&lang=js&"
export * from "./roundWarning.vue?vue&type=script&lang=js&"
import style0 from "./roundWarning.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports